import '../../css/supervisorcontrolls/supervisormenu.css';
import React, { useRef, useState, useEffect, useCallback } from 'react';
import { useTranslation } from "react-i18next";
import useMonitorAPIService from '../../services/monitorapiservice';
import ChatService from '../../services/chatservice';

function Actions(props) {

    const wrapperRef = useRef(null);
    const { t } = useTranslation();
    const { disassociate, pause, loginACD, refreshAgentStatus, intrusion } = useMonitorAPIService();
    const [loading, setLoading] = useState(false);
    const [canLogin, setCanLogin] = useState(false);
    const [canLogout, setCanLogout] = useState(false);
    const [canPause, setCanPause] = useState(false);

    useEffect(() => {
        if (!props.showActions)
            return;

        let status = props?.agent?.strAcdStatus?.toLowerCase()
        setCanLogin(status !== "free" && props.agent.ext);
        setCanLogout(props.agent.ext);
        setCanPause(status !== "paused" && props.agent.ext);

        const handleClickOutside = (e) => {
            if (props.showActions && wrapperRef.current && !wrapperRef.current.contains(e.target)) {
                props.toggleSettings();
            }
        }

        document.addEventListener("mousedown", handleClickOutside);

        //UNMOUNT
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    const releaseAgent = useCallback((e) => {
        e.preventDefault();
        if (canLogout) {
            setLoading(true);
            disassociate(props.agent.pin, props.agent.ext, props.token, res => {
                props.toggleSettings();
                setLoading(false);

                if (!props.dashboard) {
                    const event = new Event('reloadAgents');
                    document.dispatchEvent(event);
                }

            });
        }
    }, [props.agent.pin, props.agent.ext, props.token, props.dashboard, props.toggleSettings, canLogout, setLoading]);

    const pauseAgent = useCallback((e) => {
        e.preventDefault();
        if (canPause) {
            setLoading(true);
            pause(props.agent.pin, props.agent.ext, props.token, res => {
                props.toggleSettings();
                setLoading(false);

                if (!props.dashboard) {
                    const event = new Event('reloadAgents');
                    document.dispatchEvent(event);
                }

            });
        }
    }, [canPause, props.agent.pin, props.agent.ext, props.token, props.toggleSettings, props.dashboard]);

    const registerAgent = useCallback((e) => {
        e.preventDefault();
        if (canLogin) {
            setLoading(true);
            loginACD(props.agent.pin, props.agent.ext, props.token, res => {
                props.toggleSettings();
                setLoading(false);
                if (!props.dashboard) {
                    const event = new Event('reloadAgents');
                    document.dispatchEvent(event);
                }
            });
        }
    }, [canLogin, props.agent.pin, props.agent.ext, props.token, props.toggleSettings, props.dashboard]);

    const refreshStatus = useCallback((e) => {
        e.preventDefault();
        setLoading(true);
        refreshAgentStatus(props.token, props.agent.pin, e => {
            props.toggleSettings();
            setLoading(false);
            if (!props.dashboard) {
                const event = new Event('reloadAgents');
                document.dispatchEvent(event);
            }
        });
    }, [props.agent.pin, props.token, props.toggleSettings, props.dashboard]);

    const startRecording = useCallback((e) => {
        e.preventDefault();
    }, [props.agent.pin, props.token, props.toggleSettings, props.dashboard]);

    const stopRecording = useCallback((e) => {
        e.preventDefault();
    }, [props.agent.pin, props.token, props.toggleSettings, props.dashboard]);

    const initConversation = useCallback((e) => {
        e.preventDefault();
        if (props.agent.ext) {
            ChatService.initChat(props.agent.pin, props.agent.name, props.id, (res) => {

                props.toggleSettings();
                props.setShowChat(true);

                setTimeout(e => {
                    props.selectChat({ id: props.agent.pin + "-" + props.id + "M" })
                }, 200)

                setLoading(false);
            });
        }
    }, [props.agent.ext, props.agent.pin, props.agent.name, props.id, props.toggleSettings, props.setShowChat]);

    const tryIntrusion = useCallback((e) => {
        e.preventDefault();
        setLoading(true);
        intrusion(props.token, JSON.stringify({ ext: props.agent.ext }), e => {
            props.toggleSettings();
            setLoading(false);
        });
    }, [props.agent.ext, props.token, props.toggleSettings]);

    return (
        <div ref={wrapperRef} className={(props.dashboard ? "position-fixed" : "menu-agents") + " menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-color py-4 fs-6 w-250px actions " + (props.showActions ? "show" : "")}
            style={{
                top: props.dashboard ? 100 : 20,
                right: props.dashboard ? "" : -25
            }}
        >
            {
                props?.functions?.freePost &&
                <div className="menu-item px-5">
                    <a href='/' onClick={releaseAgent} className={"menu-link px-5 menu-link px-5 " + (!canLogout ? "text-muted" : "")}>
                        <span className="px-2">{t("releaseagent")}</span>
                    </a>
                </div>
            }

            {
                props?.functions?.setPause &&
                <div className="menu-item px-5">
                    <a href='/' onClick={pauseAgent} className={"menu-link px-5 " + (!canPause ? "text-muted" : "")}>
                        <span className="px-2">{t("pauseagent")}</span>
                    </a>
                </div>
            }
            {
                props?.functions?.registerAgent &&
                <div className="menu-item px-5">
                    <a href='/' onClick={registerAgent} className={"menu-link px-5 " + (!canLogin ? "text-muted" : "")}>
                        <span className="px-2">{t("registeragent")}</span>
                    </a>
                </div>
            }

            {
                props?.functions?.refreshStatus &&
                <div className="menu-item px-5">
                    <a href='/' onClick={refreshStatus} className="menu-link px-5">
                        <span className="px-2">{t("refreshstatus")}</span>
                    </a>
                </div>
            }

            {
                props?.functions?.record &&
                <div className="separator my-2"></div>
            }
            {
                props?.functions?.record &&
                <div className="menu-item px-5 ">
                    <a href='/' onClick={startRecording} className={"menu-link px-5 " + (!props.record ? "text-muted" : "")}>
                        <span className="px-2">{t("startrecording")}</span>
                    </a>
                </div>
            }
            {
                props?.functions?.record &&
                <div className="menu-item px-5">
                    <a href='/' onClick={stopRecording} className={"menu-link px-5 " + (!props.record ? "text-muted" : "")}>
                        <span className="px-2">{t("stoprecording")}</span>
                    </a>
                </div>
            }
            {
                props?.functions?.record &&
                <div className="separator my-2"></div>
            }

            {
                props?.functions?.chat &&
                <div className="menu-item px-5">
                    <a href='/' onClick={initConversation} className={"menu-link px-5 " + (!props.agent.ext ? "text-muted" : "")}>
                        <span className="px-2">{t("chat")}</span>
                    </a>
                </div>
            }

            {
                props?.functions?.intrusion &&
                <div className="menu-item px-5">
                    <a href='/' onClick={tryIntrusion} className={"menu-link px-5 " + (!props.agent.ext ? "text-muted" : "")}>
                        <span className="px-2">{t("intrusion")}</span>
                    </a>
                </div>
            }

        </div >

    );
}

export default Actions